import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { withBrand } from '../../../../providers/BrandProvider';

import CallToAction from '../../../shared/CallToAction/CallToAction';

import './PersonSocialLinks.scss';
import { isExternalUrl } from '../../../../helpers/isExternalUrl';
import { useRootSelector } from '../../../../store/hooks';
import { selectPageConfig } from '../../../../store/features/pageConfig';

export function PersonSocialLinks(props) {
  const {
    brand = {},
    contacts: {
      linkedIn,
      twitter,
      facebook,
      instagram,
      url,
      urlText,
      email,
      openInNewTabEnabled,
    } = {},
    hideEmail,
  } = props;
  const { t } = useTranslation();
  const pageConfig = useRootSelector(selectPageConfig);

  const urlDisplay = url?.replace(/\/$|^.+?\/\//g, '');
  const brandColor = { color: `#${brand.secondaryColor}` };
  const urlTarget = openInNewTabEnabled ? '_blank' : undefined;

  return (
    <div className="c-person-content-section__container">
      {linkedIn && (
        <p>
          <CallToAction
            type="link"
            to={linkedIn}
            style={brandColor}
            target="_blank"
          >
            <i className="fab fa-linkedin-in c-person-content-section__contacts-icon" />
            {t('event.contact.linkedIn')}
          </CallToAction>
        </p>
      )}
      {twitter && (
        <p>
          <CallToAction
            type="link"
            to={`https://x.com/${twitter}`}
            style={brandColor}
            target="_blank"
          >
            <i className="fab fa-x-twitter c-person-content-section__contacts-icon" />
            @{twitter}
          </CallToAction>
        </p>
      )}
      {facebook && (
        <p>
          <CallToAction
            type="link"
            to={`https://www.facebook.com/${facebook}`}
            style={brandColor}
            target="_blank"
          >
            <i className="fab fa-facebook-f c-person-content-section__contacts-icon" />
            {t('event.contact.facebook')}
          </CallToAction>
        </p>
      )}
      {instagram && (
        <p>
          <CallToAction
            type="link"
            to={`https://www.instagram.com/${instagram}`}
            style={brandColor}
            target="_blank"
          >
            <i className="fab fa-instagram c-person-content-section__contacts-icon" />
            {instagram}
          </CallToAction>
        </p>
      )}
      {url && (
        <p>
          <CallToAction
            type="link"
            to={url}
            style={brandColor}
            target={urlTarget}
          >
            <i className="fa fa-globe c-person-content-section__contacts-icon" />
            {urlText || urlDisplay}
            {isExternalUrl(url, pageConfig.parentDomain) && (
              <i className="fa fa-external-link-alt c-person-content-section__external-link" />
            )}
          </CallToAction>
        </p>
      )}
      {!hideEmail && email && (
        <p>
          <CallToAction
            type="link"
            to={`mailto:${email}`}
            style={brandColor}
            target="_blank"
          >
            <i className="fa fa-at c-person-content-section__contacts-icon" />
            {email}
          </CallToAction>
        </p>
      )}
    </div>
  );
}

PersonSocialLinks.propTypes = {
  contacts: PropTypes.shape({
    linkedIn: PropTypes.string,
    twitter: PropTypes.string,
    facebook: PropTypes.string,
    instagram: PropTypes.string,
    url: PropTypes.string,
    email: PropTypes.string,
  }),
  brand: PropTypes.object,
  hideEmail: PropTypes.bool,
};

export default withBrand(PersonSocialLinks);
